import { FORMAT, formatDateTime } from "Common/dateTimeUtils/format";
import classNames from "classnames";
import React, { memo, useMemo, useState } from "react";
import Styled from "./navigate.style";
const MAX_SEGMENT_COUNT = 10;
const MIN_SEGMENT_STEP = 5;
function Navigate(props) {
    const { duration, setSegment } = props;
    const [selectedSegmentIndex, setSelectedSegmentIndex] = useState(-1);
    const arrSegmentsBtn = useMemo(() => {
        const segmentWidth = Math.ceil(duration / MAX_SEGMENT_COUNT);
        const step = segmentWidth % MIN_SEGMENT_STEP === 0
            ? segmentWidth
            : segmentWidth - (segmentWidth % MIN_SEGMENT_STEP) + MIN_SEGMENT_STEP;
        const toggleSegment = (index) => {
            setSelectedSegmentIndex(index);
            setSegment(index * step);
        };
        const arrayBtnSegments = Array.from({ length: MAX_SEGMENT_COUNT }, (_, index) => {
            const isSelected = index === selectedSegmentIndex;
            const onClick = () => toggleSegment(index);
            return (React.createElement("button", { key: index, onClick: onClick, className: classNames("text-white w-100 p-0_5", isSelected && "selected") }, formatDateTime(index * step * 1000, FORMAT.TIME, true, false)));
        });
        return arrayBtnSegments;
    }, [duration, selectedSegmentIndex, setSegment]);
    return React.createElement(Styled.AudioSegments, null, arrSegmentsBtn);
}
export default memo(Navigate);
